"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Unsubscribe;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _base = require("@site/pattern-library-utils/base.functions");
var _subscriptionFunctions = require("./subscription-functions");
var _index = _interopRequireDefault(require("../../../elements/other/spinner/index"));
var _common = require("./common");
var _traffic = require("@site/pattern-library-utils/traffic");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

const PageSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "PageSection",
  class: "pl-pf9e8f1"
});
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-c1w4hlv0"
});
const SpinnerWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SpinnerWrapper",
  class: "pl-shpqjka"
});

/**
 * Gets customer ID from URL query parameters
 * @returns {string|null} Customer ID or null if not found
 */
const getCustomerId = () => {
  const cid = (0, _base.getQueryParamValue)('cid');
  return cid || null;
};

/**
 * Unsubscribe Component.
 *
 * @param {Object} props React props
 * @param {string} props.title Title text
 * @param {string} props.disclaimer Disclaimer text
 * @param {string} props.submitCtaText Submit CTA text
 * @param {string} props.cancelCtaText Cancel CTA text
 * @param {string} props.errorMessage Error message text
 * @param {string} props.successMessage Success message text
 * @param {string} props.sorryPageTitle Sorry page title text
 * @param {string} props.sorryPageDescription Sorry page description text
 * @param {string} props.sorryPageCtaText Sorry page CTA text
 * @param {string} props.sorryPageCtaUrl Sorry page cancel CTA URL
 * @param {Array} props.consents Initial consents data (for testing)
 * @returns {React.ReactElement} Unsubscribe component
 * @public
 */
function Unsubscribe({
  id,
  _name,
  title,
  subscriptionTitle,
  subscriptionDescription,
  disclaimer,
  errorMessage,
  successMessage,
  submitCtaText,
  cancelCtaText,
  sorryPageTitle,
  sorryPageDescription,
  sorryPageCtaText,
  sorryPageCtaUrl,
  consents: initialConsents
}) {
  const [consents, setConsents] = (0, _react.useState)(initialConsents || null);
  const [selectedConsents, setSelectedConsents] = (0, _react.useState)([]);
  const [success, setSuccess] = (0, _react.useState)(null);
  const [error, setError] = (0, _react.useState)(null);
  const [loading, setLoading] = (0, _react.useState)(false);
  const [updating, setUpdating] = (0, _react.useState)(false);
  const [errorOnGetConsents, setErrorOnGetConsents] = (0, _react.useState)(false);
  const [customerId, setCustomerId] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    const cid = getCustomerId();
    if (!cid) {
      setErrorOnGetConsents(true);
      (0, _traffic.logEvent)({
        eid: 'gce.sales.subscription/unsubscribe.missingcid.error',
        type: 'impression'
      });
      return;
    }
    setCustomerId(cid);
    if (!initialConsents) {
      setLoading(true);
      (0, _subscriptionFunctions.getConsentList)(cid).then(data => {
        if (data && data.consents) {
          setConsents(data.consents);
          setSelectedConsents(data.consents.map(consent => consent.consentKey));
        }
      }).catch(err => {
        setErrorOnGetConsents(true);
        (0, _traffic.logEvent)({
          eid: `eid.${err}.error.impression`,
          type: 'impression'
        });
      }).finally(() => {
        setLoading(false);
      });
    } else {
      setSelectedConsents(initialConsents.filter(consent => consent.value).map(consent => consent.consentKey));
    }
  }, [initialConsents, errorMessage]);
  const handleToggleConsent = consentKeys => {
    setSelectedConsents(consentKeys);
  };
  const handleUpdateConsents = async () => {
    const emailConsentKeys = ['EMAIL_ACCOUNT_SUMMARY', 'EMAIL_NOTIFICATION', 'EMAIL_PROMOTIONAL'];
    const updatedConsents = consents.filter(consent => emailConsentKeys.includes(consent.consentKey)).map(consent => ({
      consentKey: consent.consentKey,
      value: false,
      ifMatch: consent.metadata?.revision?.toString() || consent.ifMatch || '1'
    }));
    const payload = {
      consents: updatedConsents
    };
    (0, _traffic.logEvent)({
      eid: `gce.sales.subscription/unsubscribe.lists.update.button`,
      type: 'click'
    });
    setUpdating(true);
    try {
      const data = await (0, _subscriptionFunctions.updateConsents)(customerId, payload);
      if (data && data.success) {
        setConsents(data.consents || consents);
        setSuccess(true);
      } else {
        (0, _traffic.logEvent)({
          eid: `gce.sales.subscription/unsubscribe.lists.update.button.error`,
          type: 'impression'
        });
        setError(errorMessage);
      }
    } catch (err) {
      (0, _traffic.logEvent)({
        eid: `eid.${err}.error`,
        type: 'impression'
      });
      setError(errorMessage);
    } finally {
      setUpdating(false);
    }
  };
  return /*#__PURE__*/_react.default.createElement(PageSection, {
    id: `id-${id}`,
    dataCy: "unsubscribe-page-section",
    _name: _name,
    verticalMargin: "none",
    verticalPadding: "none"
  }, /*#__PURE__*/_react.default.createElement(Container, null, loading && consents === null && /*#__PURE__*/_react.default.createElement(SpinnerWrapper, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    size: "md"
  })), !loading && consents?.length > 0 && !success && /*#__PURE__*/_react.default.createElement(_common.UnsubscribePage, {
    id,
    _name,
    title,
    successMessage,
    errorMessage,
    subscriptionTitle,
    subscriptionDescription,
    disclaimer,
    submitCtaText,
    cancelCtaText,
    consents,
    selectedConsents,
    handleToggleConsent,
    handleUpdateConsents,
    updating,
    error,
    success
  }), !loading && (consents?.length === 0 || success) && /*#__PURE__*/_react.default.createElement(_common.SorryPage, {
    id,
    _name,
    successMessage,
    errorMessage,
    success,
    error,
    sorryPageTitle,
    sorryPageDescription,
    sorryPageCtaText,
    sorryPageCtaUrl
  }), !loading && errorOnGetConsents && /*#__PURE__*/_react.default.createElement(_common.ErrorPage, {
    errorMessage: errorMessage
  })));
}
Unsubscribe.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  title: _propTypes.default.string,
  subscriptionTitle: _propTypes.default.string,
  subscriptionDescription: _propTypes.default.string,
  disclaimer: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  submitCtaText: _propTypes.default.string,
  cancelCtaText: _propTypes.default.string,
  sorryPageCtaText: _propTypes.default.string,
  sorryPageCtaUrl: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  successMessage: _propTypes.default.string,
  sorryPageTitle: _propTypes.default.string,
  sorryPageDescription: _propTypes.default.string,
  consents: _propTypes.default.arrayOf(_propTypes.default.shape({
    consentKey: _propTypes.default.string.isRequired,
    value: _propTypes.default.bool.isRequired
  }))
};